import { Colors } from "./Colors"
import FONTS from "./Fonts"

const tags = {
    Inter28MediumItalic: {
        fontFamily: FONTS.Inter28MediumItalic,
    },
    orange: {
        color: Colors.Text.Orange,
    },
    Inter24Bold_Orange: {
        fontFamily: FONTS.Inter24Bold,
        color: Colors.Text.Orange
    },
    Inter18Italic: {
        fontSize: '18px',
        fontFamily: FONTS.Inter18Italic,
    },
    Inter28BoldItalic: {
        fontFamily: FONTS.Inter28BoldItalic,
    },
    Inter28SemiBoldItalic: {
        fontFamily: FONTS.Inter28SemiBoldItalic,
    },
    red_crossed: {
        underline: {
            color: Colors.Text.Red,
            thickness: 3,
            offset: -6
        },
        color: Colors.Text.Red
    }
}

export {
    tags
}